@if (!showConfirm) {
  <div class="row" [ngClass]="{loading: isLoading}">
    <div class="alert alert-info col-md-10" role="alert">
      <p><b>{{ resources.Info }}:</b></p>
      <div>{{ resources.PasteCSVLines}} <a
        (click)="showComponentTypeTable = !showComponentTypeTable"
      style="text-decoration: underline;cursor: pointer;">{{resources.ComponentTypeId}}</a>
      ,{{resources.ProductIndividualNumber}}
      ,{{ resources.Adjustment}}, {{resources.AdjustmentType}}
    ,{{ resources.Comment}}</div>
    <div>
      @if (showComponentTypeTable) {
        <table class="table">
          <thead>
            <tr>
              <th scope="col">{{resources.ComponentId}}</th>
              <th scope="col">{{resources.ComponentType}}</th>
            </tr>
          </thead>
          <tbody>
            @for (componentType of (componentTypes | async); track componentType) {
              <tr>
                <th scope="row">{{componentType.id}}</th>
                <td>{{componentType.name}}</td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div>
  <br>
    <div class="form-group col-md-10">
      <div class="form-group max-limit__text-div-adjustment">
        <span class="max-limit__text-font"><span class="max-limit__text-style">* </span>{{resources.MaximumEntriesAllowedForAdjustment}}</span>
      </div>
    </div>
    <div class="form-group col-md-10">
      <mat-form-field style="width: 100%;" appearance="outline">
        <mat-label>{{resources.WriteCSV}}</mat-label>
        <textarea matInput cdkTextareaAutosize style="width: 100%;font-size: 20px;" [formControl]="csvInput"
        #autosize="cdkTextareaAutosize" (ngModelChange)="csvInputChange($event)" cdkAutosizeMinRows="10" cdkAutosizeMaxRows="50"></textarea>
      </mat-form-field>
      @if (csvInput.invalid) {
        <mat-error style="overflow-wrap: anywhere;">{{getErrorMessage()}}</mat-error>
      }
      <div class="text-center">
        <button type="button" class="btn btn-primary" (click)="validate()">{{resources.Validate}}</button>
      </div>
    </div>
  </div>
}
@if (showConfirm) {
  <div class="row" [ngClass]="{loading: isLoading}">
    <div class="col-md-12 manual-adjustment-validation-container">
      <div class="manual-adjustment-validation-grid">
        <div class="manual-adjustment-validation-panel manual-adjustment-validation-panel--valid">
          <h4>&#9989; Valid List</h4>
          @if (validList.length > 0) {
            <table class="table">
              <colgroup>
              <col><col><col><col>
            </colgroup>
            <thead>
              <tr>
                <th scope="col">{{resources.ProductIndividualNumber}}</th>
                <th scope="col">{{resources.ComponentType}}</th>
                <th scope="col">{{resources.AdjustmentType}}</th>
                <th scope="col">{{resources.TotalValue}}</th>
              </tr>
            </thead>
            <tbody>
              @for (validLine of validList; track validLine) {
                <tr>
                  <td>{{validLine.productIndividualNumber}}</td>
                  <td>{{validLine.componentTypeName}}</td>
                  <td>{{validLine.adjustmentType}}</td>
                  <td class="font-weight-bold">{{validLine.total}}</td>
                </tr>
              }
            </tbody>
          </table>
        }
        @if (validList.length === 0) {
          <div class="alert alert-info">
            No valid manual adjustment records available for submission.
          </div>
        }
      </div>
      <div class="manual-adjustment-validation-panel manual-adjustment-validation-panel--invalid">
        <h4>&#10071; Invalid List</h4>
        @if (errorList.length > 0) {
          <table class="table">
            <colgroup>
            <col><col><col><col>
          </colgroup>
          <thead>
            <tr>
              <th scope="col">{{resources.ProductIndividualNumber}}</th>
              <th scope="col">{{resources.ComponentType}}</th>
              <th scope="col">{{resources.AdjustmentType}}</th>
              <th scope="col">{{resources.Message}}</th>
            </tr>
          </thead>
          <tbody>
            @for (errorLine of errorList; track errorLine) {
              <tr>
                <td>{{errorLine.productIndividualNumber}}</td>
                <td>{{errorLine.componentTypeName}}</td>
                <td>{{errorLine.adjustmentType}}</td>
                <td>{{errorLine.message}}</td>
              </tr>
            }
          </tbody>
        </table>
      }
      @if (errorList.length === 0) {
        <div class="alert alert-info">
          No invalid manual adjustment records found.
        </div>
      }
    </div>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-primary" (click)="back()" style="margin-right: 50px;">{{resources.Back}}</button>
    <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="validList.length === 0">Submit Valid List</button>
  </div>
</div>
</div>
}
